import React, { Component } from 'react'

export default class Loading extends Component {
    render() {
        return (
            <div id="loader" className={this.props.small ? 'd-flex justify-content-center' : "loader-position"} data-testid="loader">
                <div className={this.props.small ? "loader small" : "loader main"}></div>
            </div>
        )
    }
}
